import { RADashboardPortfolioType } from "@/constants/ReportDashboard/asset-enums"
import { RADashboardCardId, RADashboardCardSize } from "@/constants/ReportDashboard/cards-enums"
import { isCardAllowedForDashboardType } from "@/constants/ReportDashboard/card-exclusivity"
import { FADashboardType } from "@/constants/ReportDashboard/dashboards/dashboard-types"
import { RADashboardTabId } from "@/constants/ReportDashboard/tab-enums"
import { useTheme } from "@/contexts/RADashboardThemeContext/hooks"
import { cardSubtitleStyle, cardTitleStyle } from "@/styles/reportDashboardStyles"
import { InfoOutlined } from "@mui/icons-material"
import { Box, Typography } from "@mui/material"
import React from "react"

type DashboardKeyStringsInfoProps = {
  dashboardType: FADashboardType
}

const DashboardKeyStringsInfo: React.FC<DashboardKeyStringsInfoProps> = ({ dashboardType }) => {
  const theme = useTheme();

  const textTitleStyle = {
    ...cardTitleStyle,
    color: theme.textPrimary
  };

  const infoAreaStyle = {
    borderRadius: '8px',
    border: '1px solid lightgrey',
    padding: '12px',
    boxSizing: 'border-box'
  };

  const keyDisplay = (key: string) => (
    <Typography key={key} sx={{fontFamily: 'monospace', fontSize: 14, color: theme.textSecondary}}>
      {key}
    </Typography>
  );

  return (
    <Box sx={{flex: 3, ...infoAreaStyle}}>
      <Box display="flex" alignItems="center" gap={0.5}>
        <InfoOutlined color="info" fontSize="small" />
        <Typography style={textTitleStyle}>Key Strings</Typography>
      </Box>
      <Typography style={{...cardSubtitleStyle, color: theme.textSecondary}}>
        These keys for the json must match exactly.
        Any string shown that's not listed here can be modified freely.
      </Typography>

      <Typography style={{...textTitleStyle, marginTop: 20}}>Portfolio Type Keys</Typography>
      {Object.values(RADashboardPortfolioType).map(key => keyDisplay(key))}

      <Typography style={{...textTitleStyle, marginTop: 20}}>Tab Keys</Typography>
      {Object.values(RADashboardTabId).map(key => keyDisplay(key))}

      <Typography style={{...textTitleStyle, marginTop: 20}}>Card Keys</Typography>
      {Object.values(RADashboardCardId)
        .filter(key => isCardAllowedForDashboardType(key, dashboardType))
        .map(key => keyDisplay(key))}

      <Typography style={{...textTitleStyle, marginTop: 20}}>Card Sizes</Typography>
      {Object.values(RADashboardCardSize).map(key => keyDisplay(key))}
    </Box>
  );
}

export default DashboardKeyStringsInfo
